export const table = {
    primaryData: [
        { title: "ID", value: "id", type: "configue" },
        { title: "Name", value: "name", type: "configue" },
        { title: "Description", value: "description", type: "configue" },
        { title: "Created At", value: "createdAt", type: "configue" },
        { title: "Updated At", value: "updatedAt", type: "configue", name:"updatedAt" },
    ],
    secondaryData: [
        
        { title: "Created By", value: "createdByName", type: "configue" },
        { title: "Updated By", value: "updatedByName", type: "configue", name:"updatedByName" },
    ],
};
